import { render } from "./EduRegisterPayPage.vue?vue&type=template&id=482d3144&scoped=true"
import script from "./EduRegisterPayPage.vue?vue&type=script&lang=js"
export * from "./EduRegisterPayPage.vue?vue&type=script&lang=js"

import "./EduRegisterPayPage.vue?vue&type=style&index=0&id=482d3144&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482d3144"]])

export default __exports__